import { NgFor, AsyncPipe } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

import { MatButton } from '@angular/material/button';
import { RootState } from '@next/core-lib/app';
import { AgrPipesModule } from '@next/core-lib/pipes';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CatalogItem } from '../../models/catalog-item.model';
import { selectCatalogCategories } from '../../store/selectors';

enum Gradients {
  end = 'linear-gradient(90deg, rgba(255,255,255,0) 75%, rgba(255,255,255,1) 100%)',
  middle = 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 25%, rgba(255,255,255,0) 75%, rgba(255,255,255,1) 100%)',
  start = 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 25%)',
}

@Component({
  selector: 'app-catalog-categories',
  templateUrl: './catalog-categories.component.html',
  styleUrls: ['./catalog-categories.component.scss'],
  imports: [NgFor, MatButton, AsyncPipe, AgrPipesModule],
})
export class CatalogCategoriesComponent implements OnDestroy {
  @Input() isHighlighted = true;

  @Output() categorySelected: EventEmitter<CatalogItem> = new EventEmitter();

  gradient = Gradients.end;

  catalogCategories$ = this.store.select(selectCatalogCategories);

  private readonly scrollTracker$: Subject<HTMLElement> = new Subject();
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly store: Store<RootState>) {
    this.scrollTracker$.pipe(takeUntil(this.destroy$)).subscribe((scrolledTarget: HTMLElement) => {
      const isAtEnd = scrolledTarget.scrollLeft >= scrolledTarget.scrollWidth - scrolledTarget.clientWidth;
      const isAtStart = !scrolledTarget.scrollLeft;

      if (isAtEnd) {
        this.gradient = Gradients.start;
      } else if (isAtStart) {
        this.gradient = Gradients.end;
      } else if (this.gradient !== Gradients.middle) {
        this.gradient = Gradients.middle;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  categoriesScrolled(scrollEvent: Event) {
    const target: HTMLElement = scrollEvent.target as HTMLElement;
    this.scrollTracker$.next(target);
  }
}
